import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    wrapper: css({
        width: '100%',
        border: isHosTheme
            ? `0.5px solid ${theme.palette.secondary.dark}`
            : `1px solid ${theme.palette.grey[600]}`,
        padding: '25px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        rowGap: '40px',
        boxSizing: 'border-box',
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
        }),
    }),
    bookingLength: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',

        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),
    instalmentPlan: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),
    bookingLengthWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
    }),
    instalmentPlanWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
    }),
    studentNumber: css({
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    }),
    counter: css({
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
    }),
    iconWrapper: css({
        display: 'flex',
        padding: '4px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        border: `1px solid ${theme.palette.text.disabled}`,
        cursor: 'pointer',
        ':active': {
            background: theme.palette.text.placeholder,
        },
    }),
    activeIcon: css({
        border: `1px solid ${isHosTheme ? theme.palette.secondary.dark : theme.palette.text.secondary}`,
        cursor: 'pointer',
    }),
    disabledIcon: css({
        border: `1px solid ${theme.palette.text.disabled}`,
        cursor: 'not-allowed',
    }),
};
